import { render, staticRenderFns } from "./KyyAppModalCreateStudentOrder.vue?vue&type=template&id=4095c872&"
import script from "./KyyAppModalCreateStudentOrder.vue?vue&type=script&lang=js&"
export * from "./KyyAppModalCreateStudentOrder.vue?vue&type=script&lang=js&"
import style0 from "./KyyAppModalCreateStudentOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports